import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=32811e9b&scoped=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"
import style0 from "./Address.vue?vue&type=style&index=0&id=32811e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32811e9b",
  null
  
)

export default component.exports